import ImageWithSkeleton from '../../../../../../components/ImageWithSkeleton'

export default function Sponsors ({ race }) {
  return (
    <>
      {race?.ads?.map((ad, i) => (
        <ImageWithSkeleton key={i} {...{ src: ad, maxWidth: '640px' }} oneSize />
    ))}
      <ImageWithSkeleton {...{ src: race.sponsors, maxWidth: '640px' }} oneSize />
    </>

  )
}
